import React from 'react';

export default ({ children }) => (
    <div className="text-muted paragraph px-3">
        {children}
    </div>
);